export const dateItems = ['days', 'months', 'hours'];

export const taskDateSequence = [
	'after lead created',
	'after job accepted',
	'before main shoot',
	'after main shoot',
	'after previous task'
];

export const automatedActions = [
	{
		shortName: 'SEND_EMAIL',
		fullName: 'This task sends an email'
	},
	{
		shortName: 'SEND_QUESTIONNAIRE',
		fullName: 'This task sends a questionnaire'
	},
	{
		shortName: 'SEND_CONTRACT',
		fullName: 'This task sends a contract'
	}
];

export const modalIds = {
	appointment: {
		id: '#appointment',
		component: 'AddAppointmentModalComponent'
	},
	appointmentWithoutSchedule: '#appointmentWithoutScheduleModal',
	automation: {
		id: '#addAutomationModal',
		component: 'AddAutomationModalComponent'
	},
	extraShoot: {
		id: '#extraShootModal',
		component: 'AddExtraShootModalComponent'
	},
	extraShootWithoutSchedule: '#extraShootWithoutScheduleModal',
	todo: {
		id: '#addTodoModal',
		component: 'AddTodoModalComponent'
	}
};

export const taskTypeNames = {
	lead: 'LEAD',
	production: 'PRODUCTION',
	postProduction: 'POST_PRODUCTION'
};

export const eventTypes = {
	appointment: 'APPOINTMENT',
	extraShoot: 'EXTRA_SHOOT',
	mainShoot: 'MAIN_SHOOT'
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/workflow/tasks.model.ts